import { EuroOutlined } from "@ant-design/icons";

const PriceHeader = () => {
  return (
    <h2 className="header-section-title">
      <EuroOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Prezzario</span>
    </h2>
  );
};

export default PriceHeader;
